import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Text } from 'foundations-components/components/Text';
import FormattedPrice from 'payments-checkout-lib/components/Utilities/FormattedPrice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AppliedCreditMemo = ({
  creditMemoNumber,
  creditAmountApplied,
  isBuyerOverridesLoading,
  currencyCode,
  leftGridSize,
  rightGridSize
}) => {
  return /*#__PURE__*/_jsxs(Grid, {
    paddingInline: "600",
    paddingBlockEnd: "600",
    children: [/*#__PURE__*/_jsx(GridItem, {
      size: leftGridSize,
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-125",
        marginBlockEnd: "200",
        textAlign: "start",
        children: creditMemoNumber
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      "data-test-id": `credit-applied-${creditMemoNumber}`,
      size: rightGridSize,
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-125",
        marginBlockEnd: "200",
        textAlign: "end",
        color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default',
        children: /*#__PURE__*/_jsx(FormattedPrice, {
          currencyCode: currencyCode,
          price: -creditAmountApplied,
          currencyAndAmountStyle: {
            color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default'
          }
        })
      })
    })]
  });
};
export default AppliedCreditMemo;